(function () {
  const UPDATE_DELAY = 250;

  // Prevent loops when we programmatically set qty
  let isProgrammaticQtySet = false;

  // Prevent duplicate sold-as updates (change + click both fire on same interaction)
  let soldAsUpdatePending = false;
  // Track last known values so we only reset when something *actually* changes
  let lastVariantId = null;
  let lastSoldAsValue = null;
  /* =====================================
     MODE FROM LIQUID
     window.soldAsMode = "single" | "pair" | "both"
  ====================================== */
  function getMode() {
    return (window.soldAsMode || "both").toLowerCase();
  }
  /* =====================================
     GET ACTIVE VARIANT (Dawn Safe)
  ====================================== */
  function getActiveVariantId() {
    const el = document.querySelector('variant-selects [data-selected-variant]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent).id;
    } catch {
      return null;
    }
  }
  /* =====================================
     GET INVENTORY FROM INLINE JSON
  ====================================== */
  function getInventory(variantId) {
    const script = document.querySelector('[id^="ProductVariantData-"]');
    if (!script) return 0;
    try {
      const data = JSON.parse(script.textContent);
      const variant = data.variants.find(v => String(v.id) === String(variantId));
      return variant ? Number(variant.inventory_quantity || 0) : 0;
    } catch {
      return 0;
    }
  }

  /* =====================================
     CHECK IF INVENTORY IS TRACKED
  ====================================== */
  function isInventoryTracked(variantId) {
    const script = document.querySelector('[id^="ProductVariantData-"]');
    if (!script) return true; // default to tracked (safe fallback)
    try {
      const data = JSON.parse(script.textContent);
      const variant = data.variants.find(v => String(v.id) === String(variantId));
      if (!variant) return true;
      // Not tracked if inventory_management is not shopify, OR policy is "continue"
      return variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
    } catch {
      return true;
    }
  }
  /* =====================================
     CART CALCULATION
  ====================================== */
  async function getCartUnits(variantId) {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      let totalUnits = 0;
      cart.items.forEach((item, idx) => {
        if (String(item.variant_id) !== String(variantId)) return;
        const qty = Number(item.quantity || 0);
        const unitsPer = parseInt(item.properties?._units_per || "1", 10);
        const lineUnits = qty * unitsPer;
        totalUnits += lineUnits;
      });
      return totalUnits;
    } catch {
      return 0;
    }
  }

  /* =====================================
     SOLD AS READERS
  ====================================== */
  // Your hidden input (you mentioned pricing changes)
  function getSoldAsValue() {
    const hidden =
      document.querySelector('input[name="properties[SOLD AS]"]') ||
      document.querySelector('input[name="properties[Sold As]"]');
    return (hidden?.value || "").trim();
  }

  function isPairSelected() {
    const v = getSoldAsValue().toLowerCase();
    return v.includes("pair");
  }
  /* =====================================
     FORCE QTY = 1 (Dawn safe)
     - updates input value
     - triggers input/change so any price UI reacts
  ====================================== */
  function forceQtyOne(productInfo) {
    const qtyInput = productInfo.querySelector('.quantity__input');
    if (!qtyInput) return;
    const current = parseInt(qtyInput.value || "1", 10);
    if (current === 1) return;
    isProgrammaticQtySet = true;
    qtyInput.value = "1";
    qtyInput.setAttribute('value', '1');

    // Trigger Dawn listeners / theme price updates
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

    // Release guard after the event loop
    setTimeout(() => {
      isProgrammaticQtySet = false;
    }, 0);
  }

  /* =====================================
     CHECK IF PRODUCT IS BOGO (from product tags)
  ====================================== */
  function isProductBOGO() {
    // Check product-info data-product-tags attribute (used by product-form.js)
    const productInfo = document.querySelector('product-info');
    if (productInfo && productInfo.dataset.productTags) {
      const tags = productInfo.dataset.productTags.split(',').map(tag => tag.trim().toLowerCase());
      return tags.some(tag => tag.includes('bogo'));
    }
    return false;
  }
  /**
   * Mini-cart BOGO detection.
   * Do NOT use final_price === 0 alone — free swatches are also $0 and are not BOGO.
   * Prefer product tags on the cart row; exclude Swatch(es) product types.
   */
  function isMiniCartItemBOGO(cartItem, cartLine, variantLines) {
    const productType = String(
      cartItem?.dataset?.productType || cartLine?.product_type || ''
    ).trim().toLowerCase();

    if (productType === 'swatches' || productType === 'swatch') {
      return false;
    }
    return variantLines.some(item => item.final_price === 0);
    // const tagsFromDom = String(cartItem?.dataset?.productTags || '')
    //   .split(',')
    //   .map((tag) => tag.trim().toLowerCase())
    //   .filter(Boolean);

    // if (tagsFromDom.some((tag) => tag.includes('bogo'))) {
    //   return true;
    // }

    // const tagsFromCart = cartLine?.product_tags;
    // if (Array.isArray(tagsFromCart)) {
    //   return tagsFromCart.some((tag) => String(tag).trim().toLowerCase().includes('bogo'));
    // }
    // return false;
  }
  /* =====================================
    CORE UPDATE
  ====================================== */
  async function updatePDPMax() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    const qtyInput = productInfo.querySelector('.quantity__input');
    if (!qtyInput) return;
    const variantId = getActiveVariantId();
    if (!variantId) return;
    // 🔥 If inventory is NOT tracked, skip all sold-as inventory logic
    if (!isInventoryTracked(variantId)) return;
    const inventory = getInventory(variantId);
    // 🔥 get total used units from cart
    const cartUnits = await getCartUnits(variantId);
    // 🔥 determine CURRENT selection unitsPer
    let currentUnitsPer = 1;
    const dropdown = document.querySelector('.sold-as-dropdown');
    const isCurtainPairType = dropdown && dropdown.dataset.isCurtainPairType === "true";
    if (isCurtainPairType) {
      currentUnitsPer = 1; // curtain pair: frontend shows pair, backend treats as single
    } else if (getMode() === "pair" || (getMode() === "both" && isPairSelected())) {
      currentUnitsPer = 2;
    }
    // 🔥 Check if product is BOGO - adding 1 PAID also adds 1 FREE
    const isBOGO = isProductBOGO();
    const costPerAdd = isBOGO ? (currentUnitsPer * 2) : currentUnitsPer;
    // Universal math
    let remainingUnits = inventory - cartUnits;
    if (remainingUnits < 0) remainingUnits = 0;
    let maxDisplay = Math.floor(remainingUnits / costPerAdd);
    if (!Number.isFinite(maxDisplay) || maxDisplay < 0) {
      maxDisplay = 0;
    }
    qtyInput.max = maxDisplay;
    qtyInput.setAttribute('max', String(maxDisplay));
    let current = parseInt(qtyInput.value || "1", 10);
    // 🔥 When max is 0, set input to 0 and disable it
    if (maxDisplay === 0) {
      qtyInput.value = "0";
      qtyInput.setAttribute('value', '0');
      qtyInput.disabled = true;
      current = 0;
    } else {
      qtyInput.disabled = false;
      if (current > maxDisplay) {
        qtyInput.value = String(maxDisplay);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        current = maxDisplay;
      } else if (current < 1) {
        qtyInput.value = "1";
        current = 1;
      }
    }

    const plusBtn = productInfo.querySelector('.quantity__button[name="plus"]');
    if (plusBtn) {
      if (current >= maxDisplay || maxDisplay === 0) {
        plusBtn.setAttribute('disabled', 'disabled');
        plusBtn.classList.add('disabled');
      } else {
        plusBtn.removeAttribute('disabled');
        plusBtn.classList.remove('disabled');
      }
    }
    const minusBtn = productInfo.querySelector('.quantity__button[name="minus"]');
    if (minusBtn) {
      if (maxDisplay === 0) {
        // Out of stock: hard disable (attribute + class)
        minusBtn.setAttribute('disabled', 'disabled');
        minusBtn.classList.add('disabled');
      } else {
        // Stock available: always remove the hard disable attribute
        // (so Dawn's validateQtyRules can manage the class-based state)
        minusBtn.removeAttribute('disabled');
        // Toggle class based on qty — matches Dawn's own approach
        minusBtn.classList.toggle('disabled', current <= 1);
      }
    }
    // When max is 0, disable Add to Cart - main ATC only (exclude Get Swatch which has .product-form__get-swatch)
    const addToCartBtn = productInfo.querySelector('button[id^="ProductSubmitButton-"]:not(.product-form__get-swatch)') ||
                         productInfo.querySelector('button[name="add"].product-form__submit:not(.product-form__get-swatch)') ||
                         productInfo.querySelector('button[name="add"]:not(.product-form__get-swatch)');
    
    if (maxDisplay === 0) {
      addToCartBtn.setAttribute('disabled','disabled');
      addToCartBtn.setAttribute('aria-disabled','true');
      addToCartBtn.setAttribute('data-sold-as-inventory-disabled','true');
      addToCartBtn.classList.add('disabled');
    } else {
      addToCartBtn.removeAttribute('disabled');
      addToCartBtn.removeAttribute('aria-disabled');
      addToCartBtn.removeAttribute('data-sold-as-inventory-disabled');
      addToCartBtn.classList.remove('disabled');
    }
    // 🔥 Add input validation to block manual entry exceeding max (like mini cart)
    if (!qtyInput.dataset.pdpMaxValidatorAttached) {
      qtyInput.dataset.pdpMaxValidatorAttached = 'true';      
      qtyInput.addEventListener('input', function(e) {
        const max = parseInt(this.max || "9999", 10);
        const min = parseInt(this.min || "1", 10);
        let val = parseInt(this.value || "1", 10);
        
        if (max === 0) {
          this.value = "0";            
        } else if (val > max) {
          this.value = String(max);              
        } else if (val < min && max > 0) {
          this.value = String(min);
        }
      });

      qtyInput.addEventListener('blur', function(e) {
        const max = parseInt(this.max || "9999", 10);
        const min = parseInt(this.min || "1", 10);
        let val = parseInt(this.value || "1", 10);
        
        if (max === 0) {
          this.value = "0";
          this.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (val > max) {
          this.value = String(max);
          this.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (val < min) {
          this.value = String(min);
          this.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    }

  function safeUpdate() {
    setTimeout(updatePDPMax, UPDATE_DELAY);
  }
  /* =====================================
  WHEN SOLD AS / VARIANT CHANGES:
  Reset qty to 1 FIRST (pricing correctness)
  then update max
  ====================================== */
  function maybeResetQtyThenUpdate() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;
    const variantId = getActiveVariantId();
    const soldAs = getSoldAsValue();
    const variantChanged = variantId && String(variantId) !== String(lastVariantId);
    const soldAsChanged = soldAs !== lastSoldAsValue;
    // Update trackers
    if (variantId) lastVariantId = variantId;
    lastSoldAsValue = soldAs;
    // Reset qty to 1 when option changes (this is what you wanted)
    if (variantChanged || soldAsChanged) {
      forceQtyOne(productInfo);
    }
    safeUpdate();
  }
  /* =====================================
  Mini Cart Inventory Fucntionality
  ====================================== */
  async function updateMiniCartMax() {
    const container =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-items');

    if (!container) return;
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await cartRes.json();
    const cartItems = container.querySelectorAll('.cart-item');
    cartItems.forEach(cartItem => {
      const input =
      cartItem.querySelector('input[name="updates[]"]') ||
      cartItem.querySelector('.quantity__input');

      if (!input) return;
      const variantId = input.dataset.quantityVariantId;
      if (!variantId) return;

      // 🔥 If inventory is NOT tracked, skip capping for this item
      if (input.dataset.inventoryTracked === 'false') {
        // Custom Curtain and Roman Shade use a shared fabric inventory tracked via
        // data-yards / max set by the Liquid template. Removing max here would wipe
        // that value and break the per-item yardage check in global.js, causing a
        // false "Insufficient inventory" error on every cart update.
        const productType = input.dataset.productType;
        if (productType !== 'Custom Curtain' && productType !== 'Roman Shade') {
        input.removeAttribute('max');
        const plusBtn = cartItem.querySelector('button[name="plus"]');
        if (plusBtn) { plusBtn.removeAttribute('disabled'); plusBtn.classList.remove('disabled'); }
        }
        return;
      }
      const inventory = parseInt(input.dataset.variantInventory || "0", 10);
      if (!Number.isFinite(inventory)) return;

      const lineIndex = parseInt(input.dataset.index, 10) - 1;
      const cartLine = cart.items[lineIndex];
      if (!cartLine) return;
      // 🔥 current line unitsPer (source of truth)
      const currentUnitsPer = parseInt(cartLine.properties?._units_per || "1", 10);
      // 🔥 calculate total units in cart for this variant
      let totalUnits = 0;
      const variantLines = cart.items.filter(item => String(item.variant_id) === String(variantId));

      variantLines.forEach((item, idx) => {
        const qty = Number(item.quantity || 0);
        const unitsPer = parseInt(item.properties?._units_per || "1", 10);
        const lineUnits = qty * unitsPer;
        // Check final_price explicitly (don't use || since 0 is falsy)
        const finalPrice = item.final_price !== undefined ? item.final_price : item.price;
        const originalPrice = item.price || 0;
        totalUnits += lineUnits;
      });
      // BOGO only when the product is tagged BOGO (not merely free-priced).
      // Free swatches also have final_price === 0; treating them as BOGO halves inventory.
      const isBOGO = isMiniCartItemBOGO(cartItem, cartLine, variantLines);
      let remainingUnits = inventory - totalUnits;
      if (remainingUnits < 0) remainingUnits = 0;
      // maxDisplay = current line qty + how many more can be added
      const cartLineQty = parseInt(cartLine.quantity || "0", 10);
      // For BOGO: each +1 on PAID also adds +1 FREE, so cost is 2× unitsPer per increment
      const costPerIncrement = isBOGO ? (currentUnitsPer * 2) : currentUnitsPer;
      const additionalAllowed = Math.floor(remainingUnits / costPerIncrement);
      let maxDisplay = cartLineQty + additionalAllowed;
      if (!Number.isFinite(maxDisplay) || maxDisplay < 0) {
        maxDisplay = 0;
      }
      input.max = maxDisplay;
      input.setAttribute('max', String(maxDisplay));
      let current = parseInt(input.value || "1", 10);
      if (!Number.isFinite(current)) current = 1;
      // Only clamp if the input somehow shows more than the total allowed
      if (current > maxDisplay) {
        input.value = String(maxDisplay);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        current = maxDisplay;
      }
      const plusBtn = cartItem.querySelector('button[name="plus"]');
      if (plusBtn) {
        if (current >= maxDisplay) {
          plusBtn.setAttribute('disabled', 'disabled');
          plusBtn.classList.add('disabled');
        } else {
          plusBtn.removeAttribute('disabled');
          plusBtn.classList.remove('disabled');
        }
      }
      // 🔥 Add input validation to block manual entry exceeding max
      if (!input.dataset.maxValidatorAttached) {
        input.dataset.maxValidatorAttached = 'true';         
        input.addEventListener('input', function(e) {
          const max = parseInt(this.max || "9999", 10);
          const min = parseInt(this.min || "0", 10);
          let val = parseInt(this.value || "0", 10);         
          if (val > max) {
            this.value = String(max);
            
          } else if (val < min) {
            this.value = String(min);
          }
        });
        input.addEventListener('blur', function(e) {
          const max = parseInt(this.max || "9999", 10);
          const min = parseInt(this.min || "0", 10);
          let val = parseInt(this.value || "0", 10);
          
          if (val > max) {
            this.value = String(max);
            this.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (val < min) {
            this.value = String(min);
            this.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }
  /* =====================================
    EVENTS
  ====================================== */
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize trackers on load
    lastVariantId = getActiveVariantId();
    lastSoldAsValue = getSoldAsValue();
    updateMiniCartMax();
    safeUpdate();
  });

  document.addEventListener('product-info:loaded', () => {
    lastVariantId = getActiveVariantId();
    lastSoldAsValue = getSoldAsValue();
    safeUpdate();
  });

  document.addEventListener('change', function (e) {
    if (e.target.name === "properties[Sold As]") {
      // Skip if an update is already pending from the click handler
      if (soldAsUpdatePending) return;
      soldAsUpdatePending = true;
      setTimeout(() => { soldAsUpdatePending = false; }, UPDATE_DELAY + 50);
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;
      const qtyInput = productInfo.querySelector('.quantity__input');
      if (!qtyInput) return;
      const current = parseInt(qtyInput.value || "1", 10);
      if (current !== 1) {
      qtyInput.value = "1";
      qtyInput.setAttribute('value', '1');
      // Trigger Dawn price updates
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      safeUpdate();
      return;
    }
    // Variant change
    if (e.target.name === "id") {
      safeUpdate();
    }
  });
  // If your Sold As UI is buttons that set the hidden input via click (not change),
  // this catches it. Skips if the change handler already handled it.
  document.addEventListener('click', function (e) {
    if (isProgrammaticQtySet) return;
    const soldAsTrigger = e.target.closest('[data-sold-as], .sold-as-option, [name="properties[SOLD AS]"], [name="properties[Sold As]"]');
    if (!soldAsTrigger) return;
    // Skip if the change handler already scheduled an update
    if (soldAsUpdatePending) return;
    soldAsUpdatePending = true;
    setTimeout(() => { soldAsUpdatePending = false; }, UPDATE_DELAY + 50);

    setTimeout(() => {
      maybeResetQtyThenUpdate();
    }, 0);
  });
  //   if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  //     subscribe(PUB_SUB_EVENTS.cartUpdate, safeUpdate);
  //     subscribe(PUB_SUB_EVENTS.cartUpdate, updateMiniCartMax);
  //     document.addEventListener('cart:open', updateMiniCartMax);
  //     if (PUB_SUB_EVENTS.cartUpdateInMiniCart) {
  //       subscribe(PUB_SUB_EVENTS.cartUpdateInMiniCart, safeUpdate);
  //     }
  //   }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    const handleCartUpdate = (event) => {
      safeUpdate();          // PDP logic
      updateMiniCartMax();   // Mini cart validation
    };
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    if (PUB_SUB_EVENTS.cartUpdateInMiniCart) {
      subscribe(PUB_SUB_EVENTS.cartUpdateInMiniCart, handleCartUpdate);
    }
    document.addEventListener('cart:open', () => {
      updateMiniCartMax();
    });
  }
  window.addEventListener('pageshow', safeUpdate);
})();